import {createContext} from 'react'

const DealContext = createContext({
  changedVariant: null,
  isCreate: true,
  isStockChange: false,
})

export default DealContext
